export class GraphqlClientRequired extends Error {
  constructor() {
    super('graphqlClient is required')
  }
}
